import { Card, CardMedia, CardHeader, Box } from "@mui/material";
import React from "react";
import { blockInfo } from "../../utilities/helpers";
import { ClickAwayListener } from "@mui/base";

const RandomBlockInfo = ({ identifier, setShowBlockInfo }) => {
  return (
    <ClickAwayListener onClickAway={() => setShowBlockInfo("")}>
      <Box
        onMouseLeave={() => setShowBlockInfo("")}
        sx={{
          position: "absolute",
          zIndex: 1100,
          m: "-50px -30px -30px -10px",
          p: "50px",
          backgroundColor: "transparent",
        }}
      >
        <Card
          elevation={0}
          sx={{
            padding: "15px",
            borderRadius: "5px",
            width: "fit-content",
            boxShadow: "0px 0px 30px 19px rgb(0 0 0 / 12%)",
          }}
        >
          <CardHeader
            subheader={
              <>
                <strong>{`Image Block ${identifier}`}</strong>
                <div>{blockInfo(identifier)}</div>
                {/* <br />
                <span>{blockRatio(identifier)}</span> */}
              </>
            }
            sx={{ p: "0 0 15px 0" }}
          />
          <CardMedia
            sx={{
              height: "120px",
              width: "fit-content",
              display: "inline-block",
            }}
            component="img"
            src={`/random-blocks/${identifier}.png`}
            alt={`Image Block ${identifier}`}
          />
        </Card>
      </Box>
    </ClickAwayListener>
  );
};

export default RandomBlockInfo;
